module.exports = __webpack_public_path__ + "static/media/country_tg.ba18fef9.webp";